import { render, staticRenderFns } from "./ListarMenuItems.vue?vue&type=template&id=1066b15c&"
import script from "./ListarMenuItems.vue?vue&type=script&lang=js&"
export * from "./ListarMenuItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports